function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] != '00' ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MegaMenu extends HTMLElement {
  constructor() {
      super();
      this.timer = null;
      this.items = this.querySelectorAll('.header-menu');
      this.menus = this.querySelectorAll('.header-menu-content > .wrapper');
      this.subTrigger = this.querySelectorAll('.header-menu-content .grandchildlink_trigger');
      this.items.forEach((item) => {
          item.addEventListener('mouseenter', this.menuOpen.bind(this));
          item.addEventListener('mouseleave', this.menuClose.bind(this));
      });
      this.menus.forEach((menu) => {
          menu.addEventListener('mouseenter', this.menuEnter.bind(this));
          menu.addEventListener('mouseleave', this.menuClose.bind(this));
      });
      this.subTrigger.forEach((menu) => {
          menu.addEventListener('click', this.grandChildOpen.bind(this));
      });
  }

  menuClose() {
      let $self = this;
      this.timer = setTimeout(function(){
          document.querySelector('body').classList.remove(`desktop-menu-open-${$self.dataset.side}`);
          $self.items.forEach((item) => {
              item.classList.remove('active');
          })
          $self.subTrigger.forEach((menu) => {
            let parentId = menu.parentNode.dataset.parentLinkId;
            document.getElementById(parentId).style.width = '';
            $self.querySelector('.grandchildlink_container[open]')?.removeAttribute('open');
          });
      }, 200);
  }

  menuEnter() {
      clearTimeout(this.timer);
  }

  menuOpen(event) {
      var clickedItem = event.target;
      clearTimeout(this.timer);
      clickedItem.classList.add('active');
      document.querySelector('body').classList.add(`desktop-menu-open-${this.dataset.side}`);
      this.items.forEach((item) => {
          if(item != clickedItem) {
              item.classList.remove('active');
          }
      })
  }

	getWidestGrandChild() {
		var allContainers = this.querySelectorAll(".details_container");
		allContainers.forEach((e) => {
			this.widestGrandChild =
				e.clientWidth > this.widestGrandChild || !this.widestGrandChild
					? e.clientWidth
					: this.widestGrandChild;
		});
		return this.widestGrandChild;
	}

  grandChildOpen(event){
    const trigger = event.target;
    const parent = trigger.parentNode;
    const content = parent.querySelector('.details_container');
    const width = this.widestGrandChild || this.getWidestGrandChild();
    const id = parent.dataset.parentLinkId;
    const container = document.getElementById(id);
    container.style.width = '';
    if (parent.hasAttribute('open')) {
      parent.removeAttribute('open');
    }
    else{
      this.querySelector('.grandchildlink_container[open]')?.removeAttribute('open');
      content.style.left = container.clientWidth + 50 + 'px';
      container.style.width = container.offsetWidth + width + 50 +'px';
      parent.setAttribute('open', '');
    }
  }
}

customElements.define('mega-menu', MegaMenu);

class HeaderDrawer extends HTMLElement {
  constructor() {
      super();
      this.summary = this.querySelector('summary');
      this.parents = this.querySelectorAll('.parent > a');
      this.summary.addEventListener('click', this.summaryClick.bind(this))
      this.parents.forEach((item) => {
          item.addEventListener('click', this.itemClick.bind(this));
      });
  }
  
  itemClick(event) {
      event.preventDefault();
      event.target.closest('.parent').classList.toggle('active')
  }

  summaryClick(event) {
      if(this.summary.parentNode.hasAttribute('open')) {
          document.body.classList.remove('mobile-menu-open');
      } else {
          document.body.classList.add('mobile-menu-open');
      }
  }
}

customElements.define('header-drawer', HeaderDrawer);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          if (typeof Swiper === "function") { 
            this.initSlider(this);
          } else {
            const _this = this;
            document.addEventListener("swiper-loaded", function(event) {
              _this.initSlider(_this);
            });
            
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }

  initSlider(self) {
    new Swiper(`.section-${self.dataset.section} .product-recommendations_slides_container`, {
      slidesPerView: 2,
      grabCursor: true,
      spaceBetween: 15,
      mousewheel: {
          forceToAxis: true,
      },
      navigation: {
        nextEl: `.section-${self.dataset.section} .swiper-button-next`,
        prevEl: `.section-${self.dataset.section} .swiper-button-prev`,
      },
      breakpoints: {
        768: {
          slidesPerView: self.dataset.desktopSlide,
          spaceBetween: 20,
        }
      }
  });

  }

}

customElements.define('product-recommendations', ProductRecommendations);


class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
    this.maxRecommended = this.dataset.maxReco || this.dataset.desktopSlide * 2 || 10;
    if (this.dataset.slider) {
      this.loadSlider();
    }
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.init();
    }
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }

  async init() {
    const productsIds = this.getProductsIds();
    if(productsIds && productsIds.length > 0) {
      const responses = await this.getResults(productsIds);
      if (responses.length > 0) {
        const limit = Math.round(this.maxRecommended / productsIds.length);
        this.parentElement.querySelector('.swiper-wrapper.fallback-collection')?.remove();
        for (let i = 0; i < limit; i++) {
          responses.forEach(response => {
            var inserted = false;
            while (!inserted) {
              if(typeof response != 'undefined') {
                const element = response[i];
                if (element) { 
                  const prodId = parseInt(element?.querySelector('[data-product-id]')?.dataset.productId);
                  if(prodId && !productsIds.includes(prodId)){
                    this.appendChild(element.cloneNode(true));
                    productsIds.push(prodId);
                    inserted = true;
                  } else{
                    response[i].parentNode.removeChild(response[i])
                  }
                } else {
                  inserted = true;
                }
              }
            }
          });
        }
      }
    }
    else{
      this.remove();
    }
    if (this.dataset.slider) {
      this.loadSlider();
    }
  }

  getProductsIds() {
    const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
    if (productData) {
      const products = productData.reverse().slice(0,5);
      const productsIds = products.map((product) => parseInt(product.id));
      return productsIds;
    }
    return false;
  }

  async getResults(ids) {
    const responses = [];
    for (let id of ids) {
      var url = this.dataset.url.replace('[product_id]', id);
      const response = await this.getRecommendations(url);
      responses.push(response);
    }
    return responses;
  }


  getRecommendations(url) {
    return fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector(this.tagName);

        if (recommendations && recommendations.innerHTML.trim().length) {
          return recommendations.children;
        }

      })
      .catch(e => {
        console.error(e);
      });
  }

  loadSlider() {
    const _this = this;
    if (document.body.hasAttribute("swiper-loaded")) {
      _this.initSlider();
    }
    else{
      document.addEventListener("swiper-loaded", function() {
        _this.initSlider();
      });
    }
  }

  initSlider() {
    this.slider = new Swiper(`.section-${this.dataset.section} .swiper_container`, {
      slidesPerView: this.dataset.moblieSlide,
      grabCursor: true,
      preloadImages: false,
      spaceBetween: 20,
      lazy: true,
      lazy: {
          loadPrevNext: true,
      },
      mousewheel: {
          forceToAxis: true,
      },
      navigation: {
          nextEl: `.section-${this.dataset.section} .swiper-button-next`,
          prevEl: `.section-${this.dataset.section} .swiper-button-prev`,
      },
      breakpoints: {
          768: {
              spaceBetween: 15,
              slidesPerView: this.dataset.desktopSlide,
          }
      }
    });
  }

}

customElements.define('recommended-products', RecommendedProducts);

class RecommendedProductsJson extends RecommendedProducts {
  constructor() {
    super();
  }

  getProductsIds() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }

}

customElements.define("recommended-products-json", RecommendedProductsJson);

if (!customElements.get("popup-trigger")) {
  class PopupTrigger extends HTMLElement {
    constructor() {
      super();
      this.popup = document.getElementById(this.dataset.trigger);
      if(this.popup) {
          this.addEventListener('click', this.onClick.bind(this))
          this.popup.addEventListener('click', this.onPopupClick.bind(this))
          this.close = this.popup.querySelectorAll('[data-close]')
          if(this.close) {
              this.close.forEach((close)=>{
                  close.addEventListener('click', this.onClose.bind(this))
              })
          }
      }
    }
  
    onClose(event) {
      event.preventDefault();
      document.querySelector('body').classList.remove('fav-popup-open')
      this.popup.classList.remove('active')
    }
  
    onClick(event) {
      event.preventDefault();
      document.querySelector('body').classList.add('fav-popup-open')
      this.popup.classList.add('active')
      if (!this.popup.classList.contains('data-loaded')) {
        this.popup.querySelector('.loading-overlay').classList.remove('hidden')
        var self = this;
        var http = new XMLHttpRequest();
        let sectionSelector = this.dataset.sectionSelector;
        
        http.onreadystatechange = function () {
            if (this.readyState == 4) {
                try {

                    var parser = new DOMParser();
                    var doc = parser.parseFromString(this.response, 'text/html');
                    var outerHTML = doc.querySelector(sectionSelector).outerHTML;
                    var elm = self.popup.querySelector('.content');
                    self.popup.querySelector('.loading-overlay').classList.add('hidden')
                    elm.innerHTML = outerHTML;
                    self.popup.classList.add('data-loaded');
                } catch(err) {
                    console.log(err.message + " in " + this.response);
                    return;
                }
            }
        };
        
        let url = this.dataset.url;
    
        http.open('GET', url, true);
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.send();
      }
  
    }
  
    onPopupClick(event) {
        if(event.target.getAttribute('id') == this.dataset.trigger) {
          this.onClose(event);
      }
    }
  }
  
  customElements.define('popup-trigger', PopupTrigger);
}



if (!customElements.get("progress-bar")) {
  class progressBar extends HTMLElement {
    constructor() {
      super();
      this.usaTimezones = ["America/Boise", "America/Chicago", "America/Denver", "America/Detroit", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Los_Angeles", "America/Menominee", "America/New_York", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Phoenix"];
      this.isReached = false;
    }
    connectedCallback() {
      if (!window.cart_discount_enabled) { 
        this.setProgressBar()
      }
    }

    //called from discounter.bundled.js
    setProgressBar() {
      let countryCode;
      let threshold;
      if (this.dataset.cookieId && document.cookie && document.cookie.match(this.dataset.cookieId)) {
        countryCode = document.cookie
          .match(`(^|;)\\s*${this.dataset.cookieId}\\s*=\\s*([^;]+)`)
          ?.pop();
      } else {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        countryCode =  this.usaTimezones.includes(userTimezone) ? 'US' : 'REST';
        document.cookie = `${this.dataset.cookieId}=${countryCode}; max-age=86400; path=/;`;
      }
      threshold = countryCode == 'US' ? window.shipping_threshold.us : window.shipping_threshold.world;
      this.isReached = this.dataset.cartTotal >= threshold * 100;
      // const className = this.isReached ? 'reached' : '';
      // this.querySelector('#freeshipping_message_container').className = className;
      if (this.isReached) {
        this.querySelector('#freeshipping_message_container').classList.add('reached');
        document.querySelector('.totals__shipping-value').classList.add('reached');
      }
      this.querySelector('[data-shipping-price-left]').innerHTML = formatMoney(threshold * 100 - this.dataset.cartTotal);
      this.querySelector('progress').value = this.dataset.cartTotal / threshold;
    }

  }
  
  customElements.define('progress-bar', progressBar);
}
